export class CreatePickUpSession {
    creationResult: string;
    documentUrl: string;
    placardId: string;
}